import { useQuery } from '@tanstack/react-query';
import { translationsApi } from '@api/translations';

/**
 * Namespace directory (keyCount + present language codes per namespace) from the
 * dedicated `GET /localization/namespaces` endpoint. Shared by the filter
 * sidebar, the create/edit drawer's namespace picker and the namespace manager.
 *
 * Keyed under the `['translations', …]` prefix so the broad
 * `invalidateQueries({ queryKey: ['translations'] })` fired after any key or
 * namespace mutation refreshes it alongside the list.
 */
export function useNamespaces() {
  return useQuery({
    queryKey: ['translations', 'namespaces'],
    queryFn: () => translationsApi.getNamespaces(),
    staleTime: 60_000,
  });
}
